import React, { useEffect, useMemo } from "react";
import { Button, Drawer, Form, Input, InputNumber, Space, Switch } from "antd";

export default function PopularSearchDrawer({
  open,
  onClose,
  onSubmit,
  loading,
  initialValues,
}) {
  const [form] = Form.useForm();
  const isUpdate = Boolean(initialValues?.id);

  const initial = useMemo(
    () => ({
      label: initialValues?.label || "",
      searchQuery: initialValues?.searchQuery || "",
      searchCount: initialValues?.searchCount ?? 0,
      ranking: initialValues?.ranking ?? 0,
      active: initialValues?.active ?? true,
    }),
    [initialValues],
  );

  useEffect(() => {
    if (open) {
      form.setFieldsValue(initial);
    } else {
      form.resetFields();
    }
  }, [form, initial, open]);

  const handleFinish = async (values) => {
    await onSubmit({
      ...values,
      searchCount: values.searchCount ?? 0,
      ranking: values.ranking ?? 0,
      active: values.active ?? true,
    });
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      width={520}
      zIndex={2000}
      title={isUpdate ? "Edit Popular Search" : "Add Popular Search"}
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            {isUpdate ? "Update" : "Save"}
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish} requiredMark={false}>
        <Form.Item
          name="label"
          label="Label"
          rules={[{ required: true, message: "Label is required" }]}
        >
          <Input placeholder="e.g. House cleaning services" autoComplete="off" />
        </Form.Item>

        <Form.Item
          name="searchQuery"
          label="Search Query"
        >
          <Input placeholder="e.g. house cleaning, domestic worker" autoComplete="off" />
        </Form.Item>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
          <Form.Item name="searchCount" label="Search Count">
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="ranking" label="Ranking">
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="active" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
